const defaultTheme = require('tailwindcss/defaultTheme')

module.exports = {
  target: 'ie11',
  theme: {
    zIndex: {
      0: 0,
      10: 10,
      20: 20,
      30: 30,
      40: 40,
      50: 50,
      1000: 1000
    },
    extend: {
      transitionProperty: {
        size: 'height, width',
        flex: 'flex'
      },
      fontFamily: {
        sans: ['Inter var', ...defaultTheme.fontFamily.sans]
      },
      screens: {
        ...defaultTheme.screens,
        wrap: '900px',
        orders: '350px',
        print: { raw: 'print' }
      }
    }
  },
  variants: {
    borderWidth: ['responsive', 'last', 'hover', 'focus'],
    width: ['responsive', 'last', 'hover']
  },
  plugins: [
    require('@tailwindcss/ui')
  ]
}
